import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const getStartedListNudgeEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-get-started-list-entrypoint" */ './index'),
	),
	getPreloadProps: () => ({}),
});
